import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import {
  FormBuilderFieldTypes,
  FormBuilderValidation,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { RegularExpressions } from 'src/app/core/constants/regular-expressions';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { PeriodicDateConfig } from 'src/app/shared/components/periodic-date-picker/periodic-date-picker.component';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';

@Component({
  selector: 'app-form-fields-validations',
  templateUrl: './form-fields-validations.component.html',
  imports: [BaseFormModule],
})
export class FormFieldsValidationsComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  @Input() fieldType: FormBuilderFieldTypes;
  @Input() model: FormBuilderValidation;
  @Input() isEditMode: boolean;
  @Input() fieldsClass: string = 'sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4';

  @Output() modelChange = new EventEmitter<FormBuilderValidation>();

  isShowRegex: boolean = false;
  isShowMaxFileSizeByMegabyte: boolean = false;
  isShowMinValue: boolean = false;
  isShowMaxValue: boolean = false;
  isShowMaxLength: boolean = false;
  isShowMinLength: boolean = false;
  isShowDateTimeMaxValue: boolean = false;
  isShowDateTimeMinValue: boolean = false;

  periodicDateConfig: PeriodicDateConfig;

  //#endregion

  ngOnInit() {
    this.fields = 'pages.fieldsManagement.form.fields.';
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.fields = 'pages.fieldsManagement.form.fields.';

    if (changes['fieldType']) this.changeFieldType();
  }

  setComponentsConfig() {
    try {
      this.periodicDateConfig = {
        startDateLabel: this.fields + 'minValue',
        endDateLabel: this.fields + 'maxValue',
        startDateFormControl: this.form?.get('dateTimeMinValue') as FormControl,
        endDateFormControl: this.form?.get('dateTimeMaxValue') as FormControl,
        isEditMode: this.formPageConfig?.isEditMode,
        minStartDateType: 'unlimited',
        isShowEndDate: true,
        isShowStartDate: true,
        startDateValue: this.model?.dateTimeMinValue,
        endDateValue: this.model?.dateTimeMaxValue,
      };
    } catch (error) {
      this.loggerService.logError(
        'form-fields-validations',
        error,
        EventTypes.whiteMessages
      );
    }
  }

  //#region init methods

  initForm() {
    this.form = new FormGroup({
      isRequired: new FormControl(''),
      maxValue: new FormControl(''),
      minValue: new FormControl(''),
      maxLength: new FormControl(''),
      dateTimeMaxValue: new FormControl(''),
      dateTimeMinValue: new FormControl(''),
      regexValidation: new FormControl(''),
      maxFileSizeByMegabyte: new FormControl(''),
    });
  }

  hideValidationFields() {
    this.isShowMaxFileSizeByMegabyte = false;
    this.isShowMaxLength = false;
    this.isShowMinLength = false;
    this.isShowMinValue = false;
    this.isShowMaxValue = false;
    this.isShowDateTimeMaxValue = false;
    this.isShowDateTimeMinValue = false;
    this.isShowRegex = false;
  }

  changeFieldType() {
    this.hideValidationFields();

    switch (this.fieldType) {
      case FormBuilderFieldTypes.File:
        this.isShowMaxFileSizeByMegabyte = true;
        break;
      case FormBuilderFieldTypes.ShortText:
        this.isShowMaxLength = true;
        this.isShowMinLength = true;
        break;
      case FormBuilderFieldTypes.BigText:
        this.isShowMaxLength = true;
        this.isShowMinLength = true;
        break;
      case FormBuilderFieldTypes.DecimalNumber:
        this.isShowMinValue = true;
        this.isShowMaxValue = true;
        break;
      case FormBuilderFieldTypes.Date:
        this.isShowDateTimeMinValue = true;
        this.isShowDateTimeMaxValue = true;
        this.setComponentsConfig();
        break;
      case FormBuilderFieldTypes.Integer:
        this.isShowMinValue = true;
        this.isShowMaxValue = true;
        break;
      case FormBuilderFieldTypes.Email:
        this.isShowRegex = true;
        break;
      case FormBuilderFieldTypes.MobileNumber:
        this.isShowRegex = true;
        break;
      case FormBuilderFieldTypes.Regex:
        this.isShowRegex = true;
        break;
    }
    this.setDefaultValidations();
  }

  setDefaultValidations() {
    switch (this.fieldType) {
      case FormBuilderFieldTypes.NationalCode:
        this.model.minLength = 10;
        this.model.maxLength = 10;
        break;
      // case FormBuilderFieldTypes.MobileNumber:
      //   this.model.regexValidation =
      //     RegularExpressions.mobileNumberPrefixTo98Global.toString();
      //   break;
      case FormBuilderFieldTypes.Integer:
        this.model.regexValidation =
          RegularExpressions.justIntegerNumbers.toString();
        break;
      case FormBuilderFieldTypes.DecimalNumber:
        this.model.regexValidation =
          RegularExpressions.justDecimalNumbers.toString();
        break;
    }
  }

  emitModel() {
    if (this.fieldType == FormBuilderFieldTypes.Date)
      if (this.model.dateTimeMinValue)
        this.model.dateTimeMinValue = DateTimeService.toUTC(
          this.model.dateTimeMinValue
        );
    if (this.model.dateTimeMaxValue)
      this.model.dateTimeMaxValue = DateTimeService.toUTC(
        this.model.dateTimeMaxValue
      );

    this.modelChange.emit(this.model);
  }
}
